import React from 'react';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { Divider, ScreenTitle } from 'src/components/design-system';
import { ContactsUploadWizard } from '../csv-upload';
import styles from './contact-upload-management.module.scss';
import classNames from 'classnames';
import { AllSettingsButton } from '../../settings.page.component';

export const ContactUploadManagement = () => {
  const lang = useSelector(getLang('SETTINGS'));

  return (
    <div className={classNames('new-design-system', styles.root)}>
      <AllSettingsButton />
      <ScreenTitle containerStyle={styles.title} title={lang.CONTACT_UPLOAD} />
      <Divider />
      <div className={styles.content}>
        <ContactsUploadWizard />
      </div>
    </div>
  );
};
